// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3Kfna","footer":"ModalError_footer__2pW8B"};